import React from 'react';

// A thin, always-visible strip distinct from OziraContextBar: not identity/
// navigation, but trust/status -- which environment this is, whether the
// session is real, and whether anything is running degraded. Exists so a
// non-production environment is never visually mistaken for production, and
// so a degraded capability is never silently invisible.
export interface OziraTrustRailProps {
  environment: 'development' | 'staging' | 'production';
  authState: 'authenticated' | 'unauthenticated' | 'loading';
  note?: string;
}

const ENV_LABEL: Record<OziraTrustRailProps['environment'], string> = {
  development: 'DEVELOPMENT',
  staging: 'STAGING',
  production: 'PRODUCTION',
};

export function OziraTrustRail({ environment, authState, note }: OziraTrustRailProps) {
  if (environment === 'production' && authState === 'authenticated' && !note) return null; // nothing to say
  return (
    <div className={`ozira-trust-rail ozira-trust-rail--${environment}`} role="status">
      <span className="ozira-trust-rail__env">{ENV_LABEL[environment]}</span>
      <span className="ozira-trust-rail__auth">
        {authState === 'authenticated' ? 'Signed in' : authState === 'loading' ? 'Checking session…' : 'Not signed in'}
      </span>
      {note ? <span className="ozira-trust-rail__note">{note}</span> : null}
    </div>
  );
}
